import { SERVICING_ROUTES } from '@conf/routes.config';
export const FEATURE_TO_ROUTE_MAPPING: Record<string, string> = {
  'S01-P010': SERVICING_ROUTES.bookingSearch,
  'S01-P020': SERVICING_ROUTES.bookingList,
  'S02-P011': SERVICING_ROUTES.myCarValetInput,
  'S02-P020': SERVICING_ROUTES.serviceRequestPaymentInput,
  'S02-P012': SERVICING_ROUTES.petInput,
  'S02-P013': SERVICING_ROUTES.juniorPilotInput,
  'S06-P010': SERVICING_ROUTES.dutyFreePreorderGuidance,
  'S06-P020': SERVICING_ROUTES.yamatoBaggageGuidance,
  'E02-P030': SERVICING_ROUTES.involuntaryReview,
  'E02-P010': SERVICING_ROUTES.involuntaryFlightSearch,
  'C01-P010': SERVICING_ROUTES.checkinSearch,
  'S05-P040': SERVICING_ROUTES.anabizUsageStatementSelect,
  'S05-P031': SERVICING_ROUTES.emdSelect,
  'E04-P010': SERVICING_ROUTES.upgradeFlightSelect,
  'S03-P010': SERVICING_ROUTES.seatMap,
  'S03-P020': SERVICING_ROUTES.seatMap,
  'R01-P080': SERVICING_ROUTES.paymentInput,
  'S01-P030': SERVICING_ROUTES.myBooking,
  'E03-P020': SERVICING_ROUTES.refundCompleted,
  'S02-P030': SERVICING_ROUTES.serviceRequestCompleted,
  'R01-P010': SERVICING_ROUTES.flightSearch,
};

export const PAGE_ID_00485 = '00485';

export const EXTERNAL_SITE_CATEGORY_BIZ_MNT = 'BIZ_MNT';
